import { Box, Text } from "@mantine/core";

export const LineItemSubItem = ({ text }: { text: string }) => {
  return (
    <Box
      px="md"
      py="2px"
      style={(theme) => ({ borderRadius: theme.radius.lg, border: "1px solid gray" })}
    >
      <Text color="white">{text}</Text>
    </Box>
  );
};
